import React from 'react';
import { Pagination, PaginationItem, Box } from '@mui/material';
import styles from './PropertyPagination.module.css';

const CustomBackIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 1.2L1.2 11M1.2 11L11 20.8M1.2 11L20.8 11"
      stroke="currentColor"
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CustomForwardIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.0003 1.19992L20.8003 11M20.8003 11L11.0003 20.8M20.8003 11L1.2002 11"
      stroke="currentColor"
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

interface PropertyPaginationProps {
  count: number;
  page: number;
  onChange: (event: React.ChangeEvent<unknown>, value: number) => void;
}

export const PropertyPagination: React.FC<PropertyPaginationProps> = ({
  count,
  page,
  onChange,
}) => {
  return (
    <Box className={styles.root}>
      <Pagination
        count={count}
        page={page}
        onChange={onChange}
        shape="rounded"
        renderItem={item => (
          <PaginationItem
            slots={{ previous: CustomBackIcon, next: CustomForwardIcon }}
            {...item}
          />
        )}
      />
    </Box>
  );
};
